import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './user-name_types.2';

export function getUserName(variable?: null, options?: GqlRequestOptions) {
  const query = 'fragment UserAccountNamePart on UserAccount { full_name authenticated_name uuid } query GetUserName { user_account { ...UserAccountNamePart } }';
  return gql_request<types.GetUserName, null>('GetUserName', query, variable, { use_consumer: true, ...options });
}

